export enum AbilityGroupCheckState {
  ALL = 'all',
  PARTIAL = 'partial',
  NONE = 'none',
}
